import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkBadge, UitkBadgeTheme } from './uitk-badge.esm.js';
import { UitkBadgeSize } from '../types.esm.js';

/**
 * @deprecated do not use
 */
var UitkDealMemberBadge = /** @class */ (function (_super) {
    __extends(UitkDealMemberBadge, _super);
    function UitkDealMemberBadge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkDealMemberBadge.prototype.render = function () {
        var _a = this.props, className = _a.className, props = __rest(_a, ["className"]);
        var cssClassNames = classNames(className);
        return (React.createElement(UitkBadge, __assign({}, props, { size: UitkBadgeSize.LARGE, theme: UitkBadgeTheme.DEAL_MEMBER, className: cssClassNames })));
    };
    UitkDealMemberBadge.displayName = 'UitkDealMemberBadge';
    return UitkDealMemberBadge;
}(React.PureComponent));

export { UitkDealMemberBadge };
